import React, { Component } from 'react';
import './style.css';
import { hot } from 'react-hot-loader';

class BasicSelectField extends Component {
	render() {
		const {
			id,
			label,
			value,
			onChange,
			error,
			helperText,
			required,
			type,
			name,
			placeholder,
			style,
			marginTop,
			optionsValues,
			disabled
		} = this.props;

		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					marginTop: marginTop || 0
				}}>
				<label style={style} className="auth-form-input-header" htmlFor={id}>
					{label + '*'}
				</label>
				<div className="common-basic-input-wrapper full-width" onClick={this.handleClick}>
					<select
						disabled={disabled}
						id={id}
						name={name}
						onChange={onChange}
						value={value}
						style={{
							height: '45px',
							width: '100%',
							border: 'none',
							backgroundColor: 'transparent',
							outline: 'none'
						}}>
						<option value="" disabled selected>
							{placeholder}
						</option>
						{optionsValues.map((option, index) => (
							<option key={index} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
				</div>
				{error && <span className="error">{helperText}</span>}
			</div>
		);
	}
}

export default hot(module)(BasicSelectField);
